<template>
    <div>
      <el-form :model="formGet" status-icon ref="formGet" label-position="top" :rules="rulesEdit" class="form-get">
        
        <div>
          <el-row>
            <el-col :span="12" :offset="0">
              <el-col :span="12">
                  <el-form-item class="company-logo-block" label-position="top" label-width="100px" :label="$t('modal_settings_companyLogo')">
                      <el-upload
                              class="logo-uploader"
                              action=""
                              :show-file-list="false"
                              :http-request="handleLogoSuccess"
                              :before-upload="beforeLogoUpload">
                          <img v-if="formGet.logoUrl" :src="formGet.logoUrl" class="logo">
                          <i v-else class="el-icon-plus logo-uploader-icon"></i>
                      </el-upload>
                  </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="12" :offset="0"></el-col>
          </el-row>
          
          <el-row :gutter="40">
            <el-col :span="12" :offset="0">

              <el-row :gutter="20">
                  <el-col :span="24">
                      <el-form-item prop="name">
                          <el-input :label="$t('modal_settings_CompanyName')" v-model="formGet.name"></el-input>
                      </el-form-item>
                  </el-col>
              </el-row>

              <el-row :gutter="20">
                  <el-col :span="12">
                      <el-form-item>
                        <el-input v-model="formGet.taxNumber" :label="$t('modal_settings_taxNumber')"></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="12">
                      <el-form-item prop="currencyCode">
                          <el-select v-model="formGet.currencyCode" :placeholder="$t('modal_settings_currencyCompany')" filterable style="width: 100%;">
                              <el-option v-for="item in currencyList"
                                          :key="item.id"
                                          :label="item.name"
                                          :value="item.id">
                              </el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
              </el-row>

              <el-row :gutter="20">
                  <el-col :span="24">
                      <el-form-item>
                          <el-input :label="$t('modal_settings_tradingName')" v-model="formGet.tradingName"></el-input>
                      </el-form-item>
                  </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="24" :offset="0">
                  <el-form-item>
                    <el-date-picker
                      v-model="formGet.financialYearStartDate"
                      type="date"
                      placeholder="Financial Year Start Date"
                      value-format="dd-MM-yyyy"
                      style="width: 100%;">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                  <el-col :span="12">
                      <el-form-item>
                          <el-select v-model="formGet.businessType" :placeholder="$t('modal_settings_businessType')" filterable style="width: 100%;">
                              <el-option
                                      v-for="item in businessTypeList"
                                      :key="item.id"
                                      :label="item.lable"
                                      :value="item.lable">
                              </el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
                  <el-col :span="12">
                      <el-form-item>
                          <el-date-picker
                                  v-model="formGet.startedOn"
                                  type="date"
                                  :placeholder="$t('modal_settings_startedOn')"
                                  value-format="dd/MM/yyyy"
                                  style="width: 100%;">
                          </el-date-picker>
                      </el-form-item>
                  </el-col>
              </el-row>

              <el-row :gutter="20">
                  <el-col :span="12">
                      <el-form-item>
                          <el-input :label="$t('modal_settings_website')" v-model="formGet.website"></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="email" style="margin-bottom: 0;">
                        <el-input :label="$t('modal_settings_companyEmail')" v-model="formGet.email"></el-input>
                    </el-form-item>
                  </el-col>
              </el-row>

              <el-row :gutter="20">
                  <el-col :span="12">
                      <el-form-item>
                          <el-input type="number" :label="$t('modal_settings_phone')" v-model="formGet.primaryPhone"></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="12">
                      <el-form-item>
                          <el-input :label="$t('modal_settings_fax')" v-model="formGet.fax"></el-input>
                      </el-form-item>
                  </el-col>
              </el-row>

              <el-row :gutter="20">
                  <el-col :span="12">
                      <el-form-item>
                          <el-input :label="$t('modal_settings_totalEmployess')" v-model="formGet.totalEmployess"></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    
                  </el-col>
              </el-row>

            </el-col>
            <el-col :span="12" :offset="0">

              <el-row :gutter="20">
                  <el-col :span="12">
                      <el-form-item>
                      <el-switch v-model="formGet.isAddressAssigned" :active-text="$t('modal_address')"></el-switch>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    
                  </el-col>
              </el-row>

              <el-row v-if="formGet.isAddressAssigned" :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="countryId">
                      <el-select no-data-text="no data" v-model="formGet.countryId" :placeholder="$t('modal_settings_country')" filterable style="width: 100%;">
                          <el-option
                                  v-for="item in arrCountryId"
                                  :key="item.id"
                                  :label="item.name"
                                  :value="item.id"
                                  @click.native="setStateUpdate(item.id)">
                          </el-option>
                      </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="stateId">
                      <el-select no-data-text="no data" v-model="formGet.stateId" :placeholder="$t('modal_settings_stateProvinceCountry')" filterable style="width: 100%;">
                          <el-option
                                  v-for="item in arrStateId"
                                  :key="item.id"
                                  :label="item.name"
                                  :value="item.id"
                                  @click.native="setCityUpdate(item.id)">
                          </el-option>
                      </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row v-if="formGet.isAddressAssigned" :gutter="20">
                  <el-col :span="12">
                      <el-form-item prop="cityId">
                          <el-select no-data-text="no data" v-model="formGet.cityId" :placeholder="$t('modal_settings_city')" filterable style="width: 100%;">
                              <el-option
                                      v-for="item in arrCityId"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                              </el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
                  <el-col :span="12">
                      <el-form-item>
                        <el-input v-model="formGet.postCode" :label="$t('modal_post_code')"></el-input>
                      </el-form-item>
                  </el-col>
              </el-row>

              <el-row v-if="formGet.isAddressAssigned" :gutter="20">
                  <el-col :span="12">
                      <el-form-item prop="address">
                          <el-input :label="$t('modal_address_line_1')" v-model="formGet.address"></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="12">
                      <el-form-item>
                          <el-input :label="$t('modal_address_line_2')" v-model="formGet.address2"></el-input>
                      </el-form-item>
                  </el-col>
              </el-row>

              <el-row v-if="formGet.isAddressAssigned" :gutter="20">
                <el-col :span="12">
                  <el-form-item>
                    <el-input v-model="formGet.address3" :label="$t('modal_address_line_3')"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12"></el-col>
              </el-row>

            </el-col>
          </el-row>

        </div>

        <el-form-item>
          <el-button @click="save('formGet')" class="modal__btn" type="primary" plain size="small">{{$t('settings_companyAdditionalInfo_save')}}</el-button>
        </el-form-item>
      </el-form>
        
    </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'setting-company-general',
    components: {},
    computed: {},
    data() {
      return {
        currencyList: [],
        businessTypeList: [{
          id: 1,
          lable: 'Company'
        }, {
          id: 2,
          lable: 'Sole Trader'
        }, {
          id: 3,
          lable: 'Individual'
        }, {
          id: 4,
          lable: 'Charity'
        }, {
          id: 5,
          lable: 'NGO'
        }, {
          id: 6,
          lable: 'Government'
        }, {
          id: 7,
          lable: 'Sports Group'
        }, {
          id: 8,
          lable: 'Not For Profit'
        }],
        arrCountryId: [],
        arrStateId: [],
        arrCityId: [],
        formGet: {
          logoUrl: '',
          companyId: '',
          name: '',
          organization: '',
          tradingName: '',
          financialYearStartDate: null,
          businessType: '',
          email: '',
          fax: '',
          currencyCode: '',
          // businessDomain: '',
          taxNumber: '',
          website: '',
          totalEmployess: '',
          startedOn: '',
          primaryPhone: '',
          // todo
          isAddressAssigned: false,
          countryId: null,
          stateId: null,
          cityId: null,
          address: null,
          address2: null,
          address3: null,
          postCode: null,
        },
        rulesEdit: {
          name: [
              { required: true, message: this.$i18n.t('modal_settings_pleaseInputActivityCompanyName'), trigger: 'blur' },
              { min: 5, message: `${this.$i18n.t('modal_settings_lengthShouldBe')} 5`, trigger: 'blur' }
          ],
          email: [
              { required: true, message: this.$i18n.t('modal_settings_pleaseInputEmailAdress'), trigger: 'blur' },
              { type: 'email', message: this.$i18n.t('modal_settings_pleaseInputCorrectEmailAddress'), trigger: 'blur' }
          ],
          currencyCode: [{
              required: true,
              message: this.$i18n.t('modal_settings_currencyCodeIsRequired'),
              trigger: 'blur'
          }],
          categoryId: [
              { required: true, message: 'Please input Category', trigger: 'change' }
          ],
          classificationId: [
              { required: true, message: 'Please input Classification', trigger: 'change' }
          ],
        },
      }
    },
    methods:{
      async getCompanyGeneral(tabName){
        let loader = this.$loading.show();
        await this.directories();
        await this.item();
        loader.hide()
      },
      directories(){
        return new Promise ((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/companies/directories?companyId=${this.$route.query.companyId}&operation=update`)
            .then(response => {
              this.currencyList = response.data.currencyList
              this.arrCountryId = response.data.countryList
              resolve(response.data)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              reject(error)
            });
        });
      },
      item(){
        return new Promise ((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/companies/item?companyId=${this.$route.query.companyId}`)
            .then(response => {
              if(response.data.item){
                this.formGet.companyId = response.data.item.id
                this.formGet.name = response.data.item.name
                this.formGet.email = response.data.item.email
                this.formGet.currencyCode = response.data.item.currencyId
                this.formGet.countryId = response.data.item.countryId
                this.formGet.stateId = response.data.item.stateId
                this.formGet.cityId = response.data.item.cityId
                this.formGet.address = response.data.item.address
                this.formGet.address2 = response.data.item.address2
                this.formGet.address3 = response.data.item.address3
                this.formGet.postCode = response.data.item.postCode
                this.formGet.isAddressAssigned = response.data.item.isAddressAssigned
                this.formGet.taxNumber = response.data.item.taxNumber

                let customFieldsJson = JSON.parse(response.data.item.customFieldsJson)

                // this.formGet.businessDomain = customFieldsJson.businessDomain
                this.formGet.website = customFieldsJson.website
                this.formGet.totalEmployess = customFieldsJson.totalEmployess
                this.formGet.startedOn = customFieldsJson.startedOn
                this.formGet.primaryPhone = customFieldsJson.primaryPhone
                this.formGet.tradingName = customFieldsJson.tradingName
                this.formGet.financialYearStartDate = response.data.item.financialYearStartDate
                this.formGet.businessType = customFieldsJson.businessType
                this.formGet.fax = customFieldsJson.fax

                this.formGet.logoUrl = response.data.item.additionalInfo ? response.data.item.additionalInfo.avatarUrl : ''

                if (this.formGet.countryId !== null) {
                  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                  axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                  axios
                    .post(`/api/v1/companies/directories?operation=getStateList&countryId=${this.formGet.countryId}`)
                    .then(response => {
                      console.log('---/companyVendors/directories', response.data);
                      this.arrStateId = response.data.stateList
                    })
                    .catch(error => {
                      console.log('An error occurred:', error);
                    });
                }
                if (this.formGet.stateId !== null) {
                  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                  axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                  axios
                    .post(`/api/v1/companies/directories?operation=getCityList&stateId=${this.formGet.stateId}`)
                    .then(response => {
                      console.log('---/companyVendors/directories', response.data);
                      this.arrCityId = response.data.cityList
                    })
                    .catch(error => {
                      console.log('An error occurred:', error);
                    });
                }
              }
              resolve(response.data)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              reject(error)
            });
        });
      },
      setStateUpdate(id) {
        this.formGet.stateId = null
        this.formGet.cityId = null

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companies/directories?operation=getStateList&countryId=${id}`)
          .then(response => {
            console.log('---ADD VENDOR LIST', response.data);
            // this.arrCountryId = response.data.countryList
            this.arrStateId = response.data.stateList
            // this.arrCityId = response.data.cityList
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      setCityUpdate(id) {
        this.formGet.cityId = null

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companies/directories?operation=getCityList&stateId=${id}`)
          .then(response => {
            console.log('---ADD VENDOR LIST', response.data);
            // this.arrCountryId = response.data.countryList
            // this.arrStateId = response.data.stateList
            this.arrCityId = response.data.cityList
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      save(form){
        this.$refs[form].validate((valid) => {
          let name = this.formGet.name
          if (valid) {
            if (this.formGet.isAddressAssigned == true) {
              if (this.formGet.countryId &&
                this.formGet.stateId &&
                this.formGet.cityId &&
                this.formGet.address) {
                  
                  // let selectedRows = this.gridApi.getSelectedRows();
                  if (this.formGet.website.length > 0) {
                    if (this.formGet.website.slice(0, 7) != 'http://' && this.formGet.website.slice(0, 8) != 'https://') {
                      this.formGet.website = 'http://' + this.formGet.website
                    }
                  }

                  let customFieldsJson = {
                    organization: this.formGet.name,
                    tradingName: this.formGet.tradingName,
                    businessType: this.formGet.businessType,
                    website: this.formGet.website,
                    totalEmployess: this.formGet.totalEmployess,
                    startedOn: this.formGet.startedOn,
                    primaryPhone: this.formGet.primaryPhone,
                    fax: this.formGet.fax,
                  }
                  customFieldsJson = JSON.stringify(customFieldsJson)

                  let data = {
                    avatarUrl: this.formGet.logoUrl,
                    name: this.formGet.name,
                    email: this.formGet.email,
                    currencyId: this.formGet.currencyCode,
                    customFieldsJson: customFieldsJson,
                    countryId: this.formGet.countryId,
                    stateId: this.formGet.stateId,
                    cityId: this.formGet.cityId,
                    address: this.formGet.address,
                    address2: this.formGet.address2,
                    address3: this.formGet.address3,
                    postCode: this.formGet.postCode,
                    isAddressAssigned: this.formGet.isAddressAssigned,
                    taxNumber: this.formGet.taxNumber,
                    financialYearStartDate: this.formGet.financialYearStartDate,
                  }
                  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                  axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                  axios.post(`/api/v1/companies/save-general-info?companyId=${this.$route.query.companyId}`, data)
                    .then(response => {
                      this.notification("Success", "Edit company", "success");
                    })
                    .catch(error => {
                      console.log('An error occurred:', error);
                    });
              } else {
                this.$notify({
                  title: 'Notification',
                  message: 'Enter all fields Company Address',
                  type: 'info'
                });
              }
            } else {
              this.formGet.countryId = null
              this.formGet.stateId = null
              this.formGet.cityId = null
              this.formGet.postCode = null
              this.formGet.address = null
              this.formGet.address2 = null
              this.formGet.address3 = null

              // let selectedRows = this.gridApi.getSelectedRows();
              if (this.formGet.website.length > 0) {
                if (this.formGet.website.slice(0, 7) != 'http://' && this.formGet.website.slice(0, 8) != 'https://') {
                  this.formGet.website = 'http://' + this.formGet.website
                }
              }

              let customFieldsJson = {
                organization: this.formGet.name,
                tradingName: this.formGet.tradingName,
                businessType: this.formGet.businessType,
                website: this.formGet.website,
                totalEmployess: this.formGet.totalEmployess,
                startedOn: this.formGet.startedOn,
                primaryPhone: this.formGet.primaryPhone,
                fax: this.formGet.fax,
              }
              customFieldsJson = JSON.stringify(customFieldsJson)

              let data = {
                avatarUrl: this.formGet.logoUrl,
                name: this.formGet.name,
                email: this.formGet.email,
                currencyId: this.formGet.currencyCode,
                customFieldsJson: customFieldsJson,
                countryId: this.formGet.countryId,
                stateId: this.formGet.stateId,
                cityId: this.formGet.cityId,
                address: this.formGet.address,
                address2: this.formGet.address2,
                address3: this.formGet.address3,
                postCode: this.formGet.postCode,
                isAddressAssigned: this.formGet.isAddressAssigned,
                taxNumber: this.formGet.taxNumber,
                financialYearStartDate: this.formGet.financialYearStartDate,
              }
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios.post(`/api/v1/companies/save-general-info?companyId=${this.$route.query.companyId}`, data)
                .then(response => {
                  this.notification("Success", "Edit company", "success");
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                });
            }
          }
        });
      },
      handleLogoSuccess( file, fileList ) {
        console.log("FILE",file);
        var formData = new FormData();
        formData.append('file', file.file);

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/files/create?companyId=${this.$route.query.companyId}`, formData, {'Content-Type': 'multipart/form-data'})
          .then(response => {
            console.log('---P', response.data);
            this.formGet.logoUrl = response.data.fileUrl;
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      beforeLogoUpload(file) {
        const isImage = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/tiff', 'image/webp'].indexOf(file.type) != -1;
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isImage) {
          this.$message.error(this.$t('settings_companyAdditionalInfoError_AvatartPictureMustBeJPGFormat'));
        }
        if (!isLt2M) {
          this.$message.error(this.$t('settings_companyAdditionalInfoError_AvatartPictureSizeCanNotExeed2MB'));
        }
        return isImage && isLt2M;
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    }
  }
</script>

<style lang="less" scoped>
    .form-get{
        // width:700px;
    }
    .el-autocomplete{
        width:100%;
    }
    /deep/.logo-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    /deep/.logo-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    /deep/.logo-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 200px;
        line-height: 70px !important;
        text-align: center;
    }
    /deep/.logo {
        width: 200px;
        /*height:70px;*/
        display: block;
    }
</style>
